<template>
  <div class="content">
    <!-- 筛选查询框 -->
    <el-form :inline="true" class="demo-form-inline" size="small">
      <!-- <el-form-item>
      <el-button type="primary" @click="ejectaddGoods(1)"
          >新增一级病种</el-button
        >
      </el-form-item> -->
      <el-form-item>
        <el-button type="primary" @click="ejectaddGoods(2)">新增病种</el-button>
      </el-form-item>
      <!-- <el-form-item label="病种: " style="margin-left:20px">
        <el-select
          v-model="selectCategory"
          placeholder="请选择"
          @change="selectCategoryBtn"
          clearable
        >
          <el-option
            v-for="item in categoryArr"
            :label="item.name"
            :value="item.id"
            :key="item.id"
          ></el-option>
        </el-select>
      </el-form-item> -->
    </el-form>
    <!-- 病种表格 -->
    <el-table
      border
      :data="dataList"
      style="width: 100%;overflow-y: scroll !important;"
      height="calc(100vh - 220px)"
      v-loading="loading"
      element-loading-spinner="el-icon-loading"
 
      element-loading-text="正在加载中"
    >
      <el-table-column
        type="index"
        label="序号"
        align="center"
        width="180"
      ></el-table-column>
      <!-- <el-table-column label="病种主图" width="60" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.url" alt style="width:100%" />
        </template>
      </el-table-column> -->
      <el-table-column label="病种名称" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="是否显示" align="center" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.status == 0 ? "显示" : "隐藏" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="排序(越大排名越靠前)" align="center" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.sort }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="内部筛选(左)" align="center" width="180">
          <template slot-scope="scope">
            <span>{{
              scope.row.supplyTitle ? scope.row.supplyTitle : "/"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="内部筛选(右)" align="center" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.needTitle ? scope.row.needTitle : "/" }}</span>
          </template>
        </el-table-column> -->
      <el-table-column label="操作" width="180" align="center">
        <template slot-scope="scope">
          <el-button size="mini" @click="ejectupdateGoods(scope.row)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="deleteGoods(scope.row)"
            v-if="scope.row.isParent !== 0"
            :disabled="$store.state.supUser.roleId == 1"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 产品提交表单 -->
    <el-dialog
      :title="inpitTypeName"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="form">
        <el-form-item label="病种名称" :label-width="formLabelWidth" required>
          <el-input v-model="form.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="是否显示病种: " style="margin-left:20px">
          <el-select v-model="form.status" placeholder="请选择" clearable>
            <el-option
              v-for="item in statusList"
              :label="item.name"
              :value="item.id"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序" :label-width="formLabelWidth">
          <el-input v-model="form.sort" auto-complete="off"></el-input>
        </el-form-item>
        <!-- <el-form-item
          label="内容描述(请勿输入&特殊字符)"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="form.content"
            auto-complete="off"
            type="textarea"
            rows="4"
          ></el-input>
        </el-form-item> -->
      </el-form>

      <!-- 上传文件到服务器 -->
      <!-- <el-upload
        class="upload-demo"
        :action="action"
        :multiple="false"
        :on-success="handleSuccess_cover"
        :file-list="fileList"
        list-type="picture"
        name="formData"
        :limit="1"
      >
        <el-button size="small" type="primary">点击上传病种主图(1张)</el-button>
        <div slot="tip" class="el-upload__tip">
          上传后自动覆盖之前的图,只能上传jpg/png文件，500px X 500px
        </div>
      </el-upload> -->

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateBtn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  selectCategory,
  updateCategory,
  deleteCategory,
  addCategory,
} from "@/services/answers/goodkinds.js";
import { IP } from "@/services/index.js";
export default {
  created() {
    this.select();
  },

  data() {
    return {
      goodsTitle: "",
      tableData: [],
      // 一级病种 二级病种 病种
      selectCategory: "",
      select_two_id: "",
      categoryArr: [
        { id: "0", name: "一级病种" },
        { id: "1", name: "二级病种" },
      ],
      categoryArr_one: [], //遍历一级病种
      parentId: 1, //增加二级病种时选择的一级病种id 默认为0
      isAddCategoryOne: 1, //增加一级病种还是二级病种
      dataList: [],
      goodsArr: [],
      dialogFormVisible: false,
      inpitTypeName: "",
      formLabelWidth: "120px",
      action: IP + "/uploadFile/add",
      fileList: [],
      loading: true,
      pageCount: "",
      pageSize: 8,
      form: {
        productCategory: 1,
      },
      shuf: [],
      cover: [],
      describe: [],
      statusList: [
        {
          name: "显示",
          id: 0,
        },
        {
          name: "隐藏",
          id: 1,
        },
      ],
      status: 0,
    };
  },
  methods: {
    select(e = 1) {
      // 查病种
      selectCategory(e).then((resp) => {

        this.dataList = resp.data;
        this.loading = false;
      });
    },
    // 查询病种
    selectCategoryBtn(e) {
      console.log(e);
      this.select(e);
    },
    init() {
      this.$message({
        type: "success",
        message: "查询成功!",
      });
    },
    info() {
      this.$message({
        type: "info",
        message: "查询失败",
      });
    },
    ejectupdateGoods(row) {
      
      this.dialogFormVisible = true;
      this.inpitTypeName = "修改病种";
      this.form = JSON.parse(JSON.stringify(row));
      this.fileList = [];
    },
    /* 新增一级病种先隐藏掉了 */
    ejectaddGoods(type) {
      this.dialogFormVisible = true;
      this.inpitTypeName = "新增病种";
      this.form = {};
      this.fileList = [];
    },
    handleSuccess_cover(e) {
      console.log(e);
      this.form.url = e.data;
    },
    // 提交表单按钮
    updateBtn() {
      console.log("点击了确认");
      let { id, name, status, url, sort } = this.form;
      if (!name&&(!status || status==0)) {
        this.$message({
          type: "info",
          message: "请输入必填选项",
        });
        return;
      }
      if (this.inpitTypeName == "修改病种") {
        updateCategory(this.form).then((resp) => {
  
          if (resp.code == 200) {
            this.$message({
              type: "success",
              message: "修改成功!",
            });
            this.dialogFormVisible = false;
            this.select();
          } else {
            this.info();
          }
        });
      } else if (this.inpitTypeName == "新增病种") {
        // 新增一级病种
        addCategory(this.form).then((res) => {
   
          this.$message({
            type: "success",
            message: "新增成功!",
          });
          this.dialogFormVisible = false;
          this.select();
        });
      }
    },
    deleteGoods(row) {
      console.log(row.id);
      this.$confirm("此操作将永久删除该病种, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log(row.id);
          deleteCategory(row.id).then((resp) => {
    
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.select();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleCurrentChange(e) {
      console.log("当前页：", e);
      this.selectAll(this.goodsTitle, e);
    },
    prevClick(e) {
      console.log("上一页:", e);
      this.selectAll(this.goodsTitle, e);
    },
    nextClick(e) {
      console.log("下一页:", e);
      this.selectAll(this.goodsTitle, e);
    },
  },
};
</script>

<style scoped>
.content {
  margin: 20px auto;
  width: 96%;
}
.el-pagination {
  text-align: center;
  margin: 20px;
}
.goodsTitle:hover {
  cursor: pointer;
}
.upload-demo {
  margin: 20px;
}
</style>
